import { Twitter, Facebook, Linkedin, Link2, Check } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { useState } from 'react';

export function ShareButtons({ font, className = '' }) {
  const [copied, setCopied] = useState(false);
  
  const shareUrl = `${window.location.origin}/font/${font.id}/preview`;
  const shareText = `Check out "${font.name}" - a custom AI-generated font on FuntzGuntzAI!`;
  
  const handleTwitterShare = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'width=550,height=420');
  };
  
  const handleFacebookShare = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'width=550,height=420');
  };
  
  const handleLinkedInShare = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'width=550,height=420');
  };
  
  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success('Link copied to clipboard!');
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error('Failed to copy link');
    }
  };
  
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="share-buttons">
      <span className="text-xs text-[#A1A1AA] mr-1">Share:</span>
      
      <Button
        size="sm"
        variant="outline"
        onClick={handleTwitterShare}
        className="p-2 h-8 w-8 border-[#E5E5E5] hover:bg-[#1DA1F2] hover:text-white hover:border-[#1DA1F2] rounded-none"
        data-testid="share-twitter"
        title="Share on Twitter"
      >
        <Twitter className="w-4 h-4" />
      </Button>
      
      <Button
        size="sm"
        variant="outline"
        onClick={handleFacebookShare}
        className="p-2 h-8 w-8 border-[#E5E5E5] hover:bg-[#4267B2] hover:text-white hover:border-[#4267B2] rounded-none"
        data-testid="share-facebook"
        title="Share on Facebook"
      >
        <Facebook className="w-4 h-4" />
      </Button>
      
      <Button
        size="sm"
        variant="outline"
        onClick={handleLinkedInShare}
        className="p-2 h-8 w-8 border-[#E5E5E5] hover:bg-[#0A66C2] hover:text-white hover:border-[#0A66C2] rounded-none"
        data-testid="share-linkedin"
        title="Share on LinkedIn"
      >
        <Linkedin className="w-4 h-4" />
      </Button>
      
      <Button
        size="sm"
        variant="outline"
        onClick={handleCopyLink}
        className={`p-2 h-8 w-8 border-[#E5E5E5] rounded-none ${copied ? 'bg-green-500 text-white border-green-500' : 'hover:bg-[#0A0A0A] hover:text-white'}`}
        data-testid="share-copy"
        title="Copy link"
      >
        {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4" />}
      </Button>
    </div>
  );
}
